import getWithToken from './base/get-with-token'

const getRolePermissions = getWithToken('/role-permission')

export default getRolePermissions